// Canonical Supabase client lives in src/integrations/supabase/client.ts
// This file re-exports it so legacy imports continue to work.

import { supabase } from "@/integrations/supabase/client";

export { supabase };

// Derive URL and key from the client for any code that needs raw values
const url = import.meta.env.VITE_SUPABASE_URL as string;
const anon = (import.meta.env.VITE_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY) as string;

export const SUPABASE_URL = url;
export const SUPABASE_KEY = anon;
